<template>
  <div class="list-page-container">
    <div class="breadcrumbs">资料下载</div>
    <div class="header-button">
      <el-button type="success" icon="el-icon-document-add" @click="addDocuments()">新增</el-button>
    </div>
    <div class="list-page-wrap">
      <!-- 顶部操作栏 -->
      <div class="list-page-heaser">
        <el-form ref="searchForm" class="header-search" :model="searchData" @keydown.enter.native="searchSubmit">
          <el-form-item label="标题" prop="title">
            <el-input v-model="searchData.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="searchData.description" clearable></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="category_id">
            <el-select v-model="searchData.category_id" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="searchSubmit()">查询</el-button>
            <el-button @click="resetSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <div class="list-page-table">
        <custom-table ref="customTableRef" :data="tableData" :columns="columns" :pagination="pagination"
          :height="tableHeight" row-key="seed_id" @sort-change="handleSortChange"
          @selection-change="handleSelectionChange" @current-page-change="handleCurrentChange"
          @size-change="handleSizeChange">
          <!-- 标题 -->
          <template #title="{ row }">
            <span>
              <div class="customer-info">
                <span class="customer-title">{{ row.title }}</span>
                <span class="customer-desc">{{ row.description }}</span>
              </div>
            </span>
          </template>
          <!-- 分类 -->
          <template #category="{ row }">
            <div class="type-tag">
              <span class="type-tag__text">{{ row.category }}</span>
            </div>
          </template>
          <!-- 类型 -->
          <template #type="{ row }">
            <el-tag :type="row.type" effect="plain" class="custom-type-tag">
              {{ row.type }}
            </el-tag>
          </template>
          <!-- 下载 -->
          <template #download="{ row }">
            <i @click="downloadFile(row)" class="el-icon-download download-icon"></i>
          </template>
          <!-- 提交时间 -->
          <template #created_at="{ row }">
            {{ formatDateTime(row.created_at) }}
          </template>
          <!-- 操作栏 -->
          <template #actions="{ row }">
            <span class="actions-btn">
              <el-tooltip content="编辑" placement="top" class="table-btn"><i @click="editRow(row)"
                  class="el-icon-edit-outline"></i></el-tooltip>
              <el-tooltip content="删除" placement="top" class="table-btn"><i @click="deleteListRow(row)"
                  class="el-icon-delete"></i></el-tooltip>
            </span>
          </template>
        </custom-table>
      </div>
    </div>
    <el-dialog :title="addDocumentsTitle" width="400px" :append-to-body="true" :close-on-click-modal="false"
      :visible.sync="addDocumentsVisible" @closed="closeAddDocumentsDialog()">
      <el-form ref="addDocumentsForm" :model="addDocumentsData" label-position="top">
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="文档标题" prop="title">
              <el-input v-model="addDocumentsData.title" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="文档分类" prop="category_id">
              <el-select v-model="addDocumentsData.category_id" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="文档描述" prop="description">
              <el-input v-model="addDocumentsData.description" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="文件上传" prop="file">
              <el-upload class="lab-result-upload" drag :action="uploadUrl" :on-success="handleSuccess"
                :on-error="handleError" :on-remove="handleFileRemove" :file-list="fileList"
                :on-progress="handleUploadProgress" list-type="text">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <!-- 自定义文件列表模板：显示文件名 + 删除按钮 -->
                <template #file="{ file }">
                  <div class="upload-file-item">
                    <span class="file-name">{{ file.name }}</span>
                    <el-button type="text" size="mini" @click.stop="handleFileRemove(file)" class="file-remove-btn">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="text-right">
              <el-button @click="addDocumentsVisible = false">取消</el-button>
              <el-button type="success" @click="addDocumentsSubmit()">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
import listMixin from '@/mixins/listMixin'
import CustomTable from '@/components/custom-table.vue'
import * as DICT from '@/utils/dict/fieldDictionary'

export default {
  name: 'Documents',
  mixins: [listMixin],
  components: {
    CustomTable
  },
  data() {
    return {
      dataDict: DICT,
      typeList: [],
      overview: {},
      imgUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`,
      addDocumentsTitle: '新建内容',
      addDocumentsVisible: false,
      addDocumentsData: {
        id: '',
        title: '',
        category_id: '',
        category: '',
        type: '',
        oss_id: '',
        size: '',
        created_at: ''
      },
      addDocumentsRules: {
      },
      // 列表相关数据
      searchData: {
        description: null,
        category_id: null,
        title: ''
      },
      columns: [
        { label: '标题', prop: 'title', width: '400' },
        { label: '分类', prop: 'category', width: '120' },
        { label: '文件类型', prop: 'type' },
        { label: '文件大小', prop: 'size' },
        { label: '上传日期', prop: 'created_at' },
        { label: '下载', prop: 'download' },
        { label: '操作', prop: 'actions', align: 'center' }
      ],
      queryListApi: apis.QUERY_DOCUMENTS_LIST,
      deleteListParams: {
        api: apis.DELETE_DOCUMENTS,
        id: 'id'
      },
      fileList: [],
      loading: 0,
      uploadUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_UPLOAD.url}?token=${localStorage.getItem('token')}`
    }
  },
  mounted() {
    this.queryType()
  },
  methods: {
    addDocuments() {
      this.addDocumentsTitle = '新增内容'
      this.addDocumentsVisible = true
    },
    addDocumentsSubmit() {
      this.$refs.addDocumentsForm.validate((valid) => {
        if (!valid) {
          return false
        }

        if (this.loading) {
          this.$message.error('文件还在上传中，请稍后操作')
          return false
        }

        let request = {}
        if (this.addDocumentsData.id) {
          request = {
            url: '/api/v1/admin/documents/' + this.addDocumentsData.id,
            method: 'put',
            disableSuccessMsg: true,
            disableErrorMsg: false,
            params: {
              ...this.addDocumentsData
            }
          }
        } else {
          request = {
            ...apis.SAVE_DOCUMENTS,
            params: {
              ...this.addDocumentsData
            }
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.queryListData()
                this.addDocumentsVisible = false
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      })
    },
    editRow(row) {
      console.log('编辑行：', row)
      this.addDocumentsVisible = true
      this.addDocumentsTitle = '编辑内容'
      // 映射行数据到对话框表单，并自动选中对应状态按钮
      this.addDocumentsData = {
        id: row.id,
        category_id: row.category_id,
        title: row.title,
        description: row.description,
        oss_id: row.oss_id
      }
    },
    closeAddDocumentsDialog() {
      this.addDocumentsData = {
        id: '',
        category_id: '',
        title: '',
        description: '',
        oss_id: ''
      }
      this.fileList = []
      this.$nextTick(() => {
        this.$refs.addDocumentsForm.clearValidate()
      })
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      // 注意：你的数据是10位秒级时间戳，需要乘以1000转换成毫秒
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    queryType() {
      this.typeList = []
      const request = {
        ...apis.QUERY_DOCUMENTS_OVERVIEW
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.typeList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    handleUploadProgress(event, file, fileList) {
      console.log(`文件 ${file.name} 上传进度: ${event.percent}%`)
      // this.fileList = fileList // 更新文件列表
      // 设置 loading 状态为 1，表示正在上传中
      if (event.percent === 100) {
        this.loading = 0
      } else {
        this.loading = 1
      }
    },
    handleSuccess(res, file) {
      this.addDocumentsData.oss_id = res.data.id
      // 将文件添加到列表（用于显示文件名）
      this.fileList.push({
        name: file.name, // 文件名
        id: res.data.id, // 文件OSS ID
        raw: file // 原始文件对象（保留用于后续操作）
      })
    },

    // 移除文件：从列表中删除，清空相关数据
    handleFileRemove(file) {
      // 从文件列表中过滤掉当前文件
      this.fileList = this.fileList.filter(item => item.name !== file.name)
      // 清空表单中对应的文件数据
      if (this.fileList.length === 0) {
        this.addDocumentsData.oss_id = ''
      }
    },
    handleError(error, file, fileList) {
      console.error('上传失败:', error)
    },
    downloadFile(row) {
      // 校验文件ID是否存在
      if (!row.oss_id) {
        this.$message.error('文件不存在，无法下载')
        return
      }

      // 拼接完整下载地址（OSS地址 + 文件ID）
      const downloadUrl = `${this.imgUrl}${row.oss_id}`

      // 动态创建a标签
      const link = document.createElement('a')
      link.href = downloadUrl
      // 设置下载文件名（优先用文档标题，后缀取文件类型）
      const fileExt = this.getFileExtension(row.type) // 从文件类型获取后缀
      link.download = `${row.title || '未命名文件'}${fileExt}` // 下载文件名

      // 触发点击下载
      document.body.appendChild(link)
      link.click()

      // 下载完成后移除a标签（避免DOM冗余）
      setTimeout(() => {
        document.body.removeChild(link)
        this.$message.success('下载已开始')
      }, 100)
    },
    // 辅助方法：根据文件类型获取后缀（如 "PDF" → ".pdf"）
    getFileExtension(fileType) {
      if (!fileType) return ''
      const typeMap = {
        PDF: '.pdf',
        Word: '.docx',
        Excel: '.xlsx',
        PPT: '.pptx',
        ZIP: '.zip',
        图片: '.png',
        视频: '.mp4'
      }
      // 若类型未匹配到，直接返回小写类型作为后缀
      return typeMap[fileType] || `.${fileType.toLowerCase()}`
    }
  }
}
</script>

<style scoped>
/* 客户信息样式 */
.customer-info {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  font-size: 16px;
  font-weight: 400;
}

.customer-title {
  margin-bottom: 3px;
  color: #101828;
}

.customer-desc {
  color: #6A7282;
}

.el-select {
  width: 100%;
}

.custom-type-tag {
  border-radius: 20px;
  font-size: 13px;
}

.custom-type-tag .el-icon {
  margin-right: 4px;
  font-size: 14px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.video-container {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中（可选，使视频在容器中垂直居中） */
  width: 100%;
  padding: 20px 0;
  /* 上下留白，提升视觉效果 */
}

/* 确保视频不超出容器宽度（适配小屏幕） */
.video-container video {
  max-width: 100%;
  /* 防止视频过宽溢出弹窗 */
  object-fit: contain;
  /* 保持视频比例，不拉伸 */
}

/* 编辑器整体容器 */
.quill-editor {
  width: 100%;
  height: 350px !important;
}

::v-deep .ql-container {
  height: calc(100% - 42px);
  box-sizing: border-box !important;
}

/* 下载图标样式 */
.download-icon {
  cursor: pointer;
  color: #409EFF;
  /* 初始颜色 */
  font-size: 22px;
  /* 放大图标（按需调整，如24px更大） */
  margin: 0 10px;
  /* 左右间距，避免紧贴文字 */
  transition: all 0.2s;
  /* 过渡动画，hover更丝滑 */
}

/* hover效果（可选，提升体验） */
.download-icon:hover {
  color: #32B768;
  /* hover变色 */
  transform: scale(1.1);
  /* 轻微放大，增强交互感 */
}

/* 上传文件项样式 */
.upload-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-top: 8px;
}

/* 文件名样式 */
.file-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
  /* 限制文件名最大宽度，避免溢出 */
}

/* 删除按钮样式 */
.file-remove-btn {
  color: #F56C6C;
  padding: 0 8px;
}

.file-remove-btn:hover {
  color: #ff4d4f;
}

/* 优化上传组件整体样式 */
.lab-result-upload {
  margin-top: 8px;
}

.el-upload__text {
  color: #666;
}

.table-btn {
  width: 38px;
  height: 32px;
  align-content: center;
  border: 0.8px solid #0000001A;
  border-radius: 8px;
}
</style>
